import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Programi from '../components/Home/Programi'
import Bredcom from '../components/Bredcom/Bredcom';

function SviStudijskiProgrami() {
    return (
        <>
        <Navbar />
        <Bredcom title="Početna" subtitle="Programi" />
        <Programi />
        <Footer/>
        </>
    )
}

export default SviStudijskiProgrami
